import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkAPI } from 'Redux/types';
import Selectors from 'Redux/Selectors';

import Toast from 'Lib/Toast';

import Utils from 'Lib/Utils';

import NavActions from 'Services/Navigation/Actions';
import Atc from '../../../../Lib/ATC';

import { ErrorTypes } from '.';

export interface IResetPasswordThunkParams {
    email: string;
    password: string;
    otp: string;
}

export default createAsyncThunk<
    null,
    IResetPasswordThunkParams,
    AsyncThunkAPI
>('auth/resetPasswordConfirmation', async (params, thunkAPI) => {
    const { email, password, otp } = params;

    if (!password) {
        return thunkAPI.rejectWithValue('Please enter password.');
    }

    const passwordValidateError = Utils.Validator.validatePassword(password);

    if (passwordValidateError) return thunkAPI.rejectWithValue(passwordValidateError);

    const response = await thunkAPI.extra.useCases.auth.resetPasswordConfirmation.execute({
        email,
        role: 4,
        OTP: otp,
        password,
    });

    if (response.status === Atc.UseCases.Types.UseCaseResponseStatus.Success) {
        Toast.show('Password updated');
        NavActions.navToHome();
        return null;
    }

    const { type, title } = response.data;
    const { ResetPasswordConfirmationError } = ErrorTypes;

    if (type === ResetPasswordConfirmationError.NoUserFound) {
        return thunkAPI.rejectWithValue('Account is invalid. Please refresh the page and login again.');
    }

    return thunkAPI.rejectWithValue(title || 'Something went wrong. Please try again.');
});
